var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isM)?_c('Header'):_vm._e(),(_vm.isM)?_c('HeaderMobile'):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }